import { Box, CircularProgress } from '@mui/material'

/** Полноэкранный спиннер при первичной загрузке профиля авторизованного пользователя. */
export const AuthBootstrapSpinner = () => (
  <Box
    sx={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <CircularProgress />
  </Box>
)
